import React, { lazy, Suspense, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
const AddContractsModal = lazy(() =>
  import("src/features/Modal").then((modal) => ({
    default: modal.AddContracts,
  }))
);

export default function AddContracts() {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <Button
        style={{ marginBottom: 15 }}
        icon={<PlusOutlined />}
        type="primary"
        onClick={() => setOpen(true)}
      >
        Добавить контракт
      </Button>
      {isOpen ? (
        <Suspense fallback={<div></div>}>
          <AddContractsModal isOpen={isOpen} setOpen={setOpen} />
        </Suspense>
      ) : null}
    </>
  );
}
